import { type FragmentOf, graphql, readFragment } from "@/graphql"
import { isAgreementCancelled } from "./isAgreementCancelled"
import { isAgreementTerminated } from "./isAgreementTerminated"

const graphQLFragments = {
    agreement: graphql(
        `
            fragment isAgreementEditable_Agreement on AgreementType {
                id
                chargingLedger {
                    number
                }
                ...isAgreementCancelled_Agreement
                ...isAgreementTerminated_Agreement
            }
        `,
        [isAgreementCancelled.fragments.agreement, isAgreementTerminated.fragments.agreement]
    ),
}

type IsAgreementEditableProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementEditable(props: IsAgreementEditableProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return (
        !isAgreementCancelled({ agreement }) &&
        !isAgreementTerminated({ agreement }) &&
        !!agreement.chargingLedger?.number &&
        !!agreement.id
    )
}

isAgreementEditable.fragments = graphQLFragments
